import { render, staticRenderFns } from "./CropVarieties.vue?vue&type=template&id=467b49d8&"
import script from "./CropVarieties.vue?vue&type=script&lang=js&"
export * from "./CropVarieties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports